<script>
import Vue from 'vue'

const VIEW_MODE = 'view'
const EDIT_MODE = 'edit'

export default {
    name: 'oc-field',
    functional: true,
    inject: {
        access: {
            default: false
        }
    },
    props: {
        // required
        name: {
            type: [String, Number],
            required: true
        },
        // input component type
        input: {
            type: String,
            default: 'oc-text-input'
        },
        // for v-model to work
        value: {
            default: null
        },
        // mode
        mode: {
            type: [String, Boolean],
            default: false,
            validator: function (value) {
                let valid = [false, VIEW_MODE, EDIT_MODE].indexOf(value) !== -1

                if( ! valid ) {
                    console.error(`<oc-field>: Invalid property value "${value}" for parameter "mode".`)
                }

                return valid
            }
        }
    },
    render(createElement, context) {
        let isViewMode = false

        if( context.props.mode ) {
            isViewMode = context.props.mode === VIEW_MODE
        } else if( context.injections.access ) {
            isViewMode = context.injections.access.isViewMode
        }
        // ----------------------------- //

        let targetComponent = context.props.input
        let targetChildren = undefined

        const attrs = Object.assign({}, context.data.attrs, context.props)
        delete attrs.mode

        if ( isViewMode ) {
            let viewSlot = undefined
            if( undefined !== context.slots().view ) {
                viewSlot = context.slots().view
            } else if( context.data.scopedSlots && context.data.scopedSlots.view ) {
                viewSlot = context.data.scopedSlots.view(attrs)
            }

            if(isArray(viewSlot)) {
                viewSlot = viewSlot.filter(x => x !== null && x !== undefined)
                if(viewSlot.length > 0) {
                    // if we have 'view' scoped/normal slot - return its content
                    return viewSlot
                }
            }

            if( typeof Vue.component(context.props.input + '-view') !== 'undefined' )
            {
                targetComponent = context.props.input + '-view'
            }
            else
            {
                targetComponent = 'oc-field-view'
            }
        }

        if( targetChildren === undefined ) {
            targetChildren = context.children
        }

        // fixes empty value issue when used value="123" (without v-model)
        // it occurs because value is in the context.props of the current functional component
        // In order to not break custom v-model prop of the child component we should only apply it when
        // v-model is not used (context.data.model is empty)
        if( context.data.model === undefined && context.data.attrs.value === undefined ) {
            context.data.attrs.value = context.props.value
        }

        // create props object
        if( context.data.props === undefined ) {
            context.data.props = {}
        }

        // workaround: forward attribute $value --> value (overlapping v-model prop value)
        if( context.data.attrs.$value ) {
            context.data.props.value = context.data.attrs.$value
            delete context.data.attrs.$value
        }

        // forward all $ attributes to become props
        // this fixes Vue issue: Uncaught DOMException: Failed to execute 'setAttribute' on 'Element': '$' is not a valid attribute name.
        for( let attr in context.data.attrs ) {
            if( attr.indexOf('$') === 0 ) {
                context.data.props[attr] = context.data.attrs[attr]
                delete context.data.attrs[attr]
            }
        }
        //

        // forward functional component props to the target component
        context.data.props.name = context.props.name
        context.data.attrs.name = context.props.name

        return createElement(
            targetComponent,
            Object.assign(
                {},
                context.data,
                {
                    scopedSlots: context.scopedSlots,
                    slots: context.slots,
                    on: context.listeners
                }
            ),
            targetChildren
        )
    }
}
</script>
